import {Grid} from "@mui/system";
import React from "react";
import {MdOutlineDone} from "react-icons/md";
import style from "../../assets/css/home.module.scss";
import WhyImg from "../../assets/img/home/why-img.webp";

function WhySurya() {
  return (
    <>
      <section className={style.whySuryaSection}>
        <Grid
          container
          spacing={2}
          className="customeContainer"
          justifyContent="center"
          alignItems="center"
        >
          <Grid size={{xs: 12, lg: 6, sm: 12, md: 12, xl: 6}}>
            <div className={style.whyContent}>
              <h2>
                {" "}
                Why Associated International Brokers, Inc is Your Best Choice
              </h2>
              <p>
                When it comes to Jewelers Block Insurance, choosing the right
                brokerage isn’t just about finding coverage—it’s about
                partnering with experts who understand your business, your
                risks, and your needs. At{" "}
                <strong>Associated International Brokers, Inc</strong>, we go
                beyond standard policies to offer tailored solutions, rapid
                response times, and a commitment to protecting your most
                valuable assets.
              </p>
              <ul>
                <li>
                  <MdOutlineDone />
                  <p>Expertise Rooted in the Jewelry Trade</p>
                </li>
                <li>
                  <MdOutlineDone />
                  <p>Fast & Reliable Claims & Endorsements</p>
                </li>
                <li>
                  <MdOutlineDone />
                  <p>Global Coverage, Local Service</p>
                </li>
                <li>
                  <MdOutlineDone />
                  <p>A Brokerage That Works for You</p>
                </li>
              </ul>
            </div>
          </Grid>

          <Grid size={{xs: 12, lg: 6, xl: 6}}>
            <div className={style.whyImg}>
              <img src={WhyImg} alt="whyimg" />
            </div>
          </Grid>
        </Grid>
      </section>
    </>
  );
}

export default WhySurya;
